import React from 'react';
import type { TextBlockContent } from '../../../types/popup.types';

interface TextBlockProps {
  content: TextBlockContent;
}

const TextBlock: React.FC<TextBlockProps> = ({ content }) => {
  const { html, align } = content;

  const alignClass = align === 'center' ? 'text-center' : align === 'right' ? 'text-end' : 'text-start';

  return (
    <div
      className={`mb-4 fs-5 text-gray-700 lh-lg ${alignClass}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default TextBlock;
